import axios from '@/utils/axios';

// 个人信息
export function AccountInfo(ladyId) {
    return axios({
        url: '/account',
        method: 'get',
        params: { ladyId },
    });
}

// 个人信息编辑
export function AccountUpdate(password,ladyTel) {
    return axios({
        url: '/account/update',
        method: 'post',
        params: { password, ladyTel },
    });
}
